/* Forged Racing — collection facets + sort.
   Keeps sort in sync inside the filter form so applying filters preserves sort.
   Auto-submits on change; Apply button + Clear all still work without JS. */
(function () {
  'use strict';

  function init() {
    var facets = document.querySelector('[data-frg-facets]');
    var form = document.querySelector('[data-frg-facets-form]');
    var sort = document.querySelector('[data-frg-sort]');
    if (!form) return;

    /* keep a hidden sort_by field synced into the filter form */
    var hidden = null;
    if (sort) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'sort_by';
      hidden.value = sort.value;
      form.appendChild(hidden);
      sort.addEventListener('change', function () {
        hidden.value = sort.value;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    /* auto-apply when a checkbox toggles (price inputs wait for Apply/Enter) */
    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      }
    });

    /* mobile drawer toggle */
    var toggle = document.querySelector('[data-frg-facets-toggle]');
    if (toggle && facets) {
      toggle.addEventListener('click', function () {
        var open = facets.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('forged-scroll-lock', open);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
